import React, { useLayoutEffect, useRef, RefObject } from 'react';

import FadeIn from 'src/components/elements/FadeIn';

import useIntersection from 'src/hooks/useIntersection';

import { ACHIEVEMENTS } from './constants';

import { gsap } from 'gsap';

import styles from './Earn.scss';

const Earn = () => {
  const containerRef: RefObject<HTMLDivElement> = useRef(null);
  const inViewport = useIntersection({ element: containerRef, rootMargin: '-30%' });

  useLayoutEffect(() => {
    const cards = gsap.utils.toArray('#achievement-card');

    if (inViewport) {
      gsap.fromTo(cards, { opacity: 0, x: 50 }, { opacity: 1, x: 0, stagger: 0.0625, delay: 1.5 });
    }
  }, [inViewport]);

  useLayoutEffect(() => {
    const cards = gsap.utils.toArray('#achievement-icon');

    if (inViewport) {
      gsap.fromTo(cards, { opacity: 0, x: -50 }, { opacity: 1, x: 0, stagger: 0.0625, delay: 2.5 });
    }
  }, [inViewport]);

  return (
    <div ref={containerRef} className={styles.rootContainer}>
      <div className={styles.titleContainer}>
        <FadeIn>
          <span className={styles.subtitle}>How to earn</span>
        </FadeIn>
        <FadeIn delay={1}>
          <span className={styles.title}>Planets with friends</span>
        </FadeIn>
      </div>
      <div className={styles.achievements}>
        {ACHIEVEMENTS.map((achievement) => (
          <div id="achievement-card" key={achievement.id} className={styles.achievementCard}>
            <h2 className={styles.cardTitle}>{achievement.title}</h2>
            <div className={styles.cardDescription}>{achievement.description}</div>
            <div className={achievement.id === 3 ? styles.cardIconsLeft : styles.cardIcons}>
              {achievement.icons.map((icon) => (
                <img
                  id="achievement-icon"
                  key={icon.id}
                  className={achievement.id === 3 ? styles.cardIconLeft : styles.cardIcon}
                  src={icon.src}
                  alt="card-icon"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Earn;
